// extracted by mini-css-extract-plugin
module.exports = {"block":"_373a3719ba--block--cu358","stickyBlock":"_373a3719ba--stickyBlock--c4s4K","sticky":"_373a3719ba--sticky--A7U01","button_wrap":"_373a3719ba--button_wrap--hQ_2z"};